const STYLE_ID = 'hoppinger-feedback-fonts';

/**
 * @font-face rules do not register from inside a shadow root in every browser, so they go into
 * the host document's <head>. Family names are prefixed so they cannot clash with the host's fonts.
 * The files are served by the feedback Worker (packages/widget/public/fonts) with CORS headers.
 * Fallback metrics match the ones hoppinger.com uses, so text does not jump when the fonts arrive.
 */
export function loadFonts(baseUrl: string): void {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
@font-face { font-family: 'HFB TT Commons'; font-weight: 400 800; font-display: swap;
  src: url('${baseUrl}/fonts/tt-commons-pro-variable.woff2') format('woff2'); }
@font-face { font-family: 'HFB Simula'; font-weight: 400; font-display: swap;
  src: url('${baseUrl}/fonts/simula.woff2') format('woff2'); }
@font-face { font-family: 'HFB TT Commons fallback'; src: local('Helvetica'), local('Arial');
  ascent-override: 88%; size-adjust: 96.5%; }
@font-face { font-family: 'HFB Simula fallback'; src: local('Georgia');
  ascent-override: 95%; size-adjust: 98%; }`;
  (document.head ?? document.documentElement).append(style);
}
